import { useTranslation } from "react-i18next";

import { TotalBlockProps } from "../../OrderModal.types";
import { OrderModalBlock } from "./OrderModalBlock";

import styles from "../../OrderModal.module.scss";

export const TotalBlock = ({
  label,
  items,
  totalPrice,
  totalText,
  totalIcon,
  colors: { backgroundColor, color }
}: TotalBlockProps) => {
  const { t } = useTranslation();

  return (
    <OrderModalBlock label={label}>
      <div className={styles.orderModal__totalBlock__list}>
        {items.map((item, index) => (
          <div
            className={styles.orderModal__totalBlock__listItem}
            key={`totalItem-${label}-${index}`}
          >
            <p>{t(item.label)}</p>
            <p
              className={styles.orderModal__totalBlock__listPrice}
              style={{ color }}
            >
              {item.price > 0 ? "+" : ""} {item.price.toLocaleString("en-US")}{" "}
              FCFA
            </p>
          </div>
        ))}
      </div>
      <div className={styles.orderModal__separator} />
      <div className={styles.orderModal__totalBlock__footer}>
        <div
          className={styles.orderModal__totalBlock__total}
          style={{ backgroundColor, color }}
        >
          {totalIcon}
          <p>{t(totalText)}</p>
          <p className={styles.orderModal__totalBlock__totalPrice}>
            {totalPrice > 0 ? "+" : ""} {totalPrice.toLocaleString("en-US")}{" "}
            FCFA
          </p>
        </div>
        <p className={styles.orderModal__totalBlock__text}>
          {t("This amount will be transferred to your mobile money number")}
        </p>
      </div>
    </OrderModalBlock>
  );
};
